import $api from '../services';

export default {
    getCards() {
        return $api.get('/cards');
    },
    addNewCard(data) {
        return $api.post('/cards', data);
    },
    deleteCard(id) {
        return $api.delete(`/cards/${id}`);
    },
    createSubscription(data) {
        return $api.post('/subscriptions', data);
    },
    updateSubscription(data) {
        return $api.put('/subscriptions', data);
    },
    deleteSubscription(data) {
        return $api.delete('/subscriptions', data);
    }
};
